import { asyncToGenerator as _asyncToGenerator, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { matchPath } from 'react-router-dom';
import _regeneratorRuntime from 'regenerator-runtime';
import { isAsyncComponent } from './utils.esm.js';

function loadInitialProps(_x, _x2, _x3) {
  return _loadInitialProps.apply(this, arguments);
}

function _loadInitialProps() {
  _loadInitialProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(pathname, routes, ctx) {
    var promises, matchedComponent;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            promises = [];
            matchedComponent = routes.find(function (route) {
              // matchPath dont't accept undefined path property
              // in <Switch> componet all Child <Route> components
              // have a path prop with value of "/", { path: "/" }
              // https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/Router.js#L12
              // we get arround this problem by adding { path: "*" }
              // to route that don't have path property
              var match = matchPath(pathname, _extends({}, route, {
                path: route.path || '*'
              }));

              if (match && route.component && isAsyncComponent(route.component)) {
                var component = route.component;
                promises.push(component.load ? component.load().then(function () {
                  return component.getInitialProps(_extends({
                    match: match
                  }, ctx));
                }) : component.getInitialProps(_extends({
                  match: match
                }, ctx)));
              }

              return !!match;
            });
            _context.t0 = matchedComponent;
            _context.next = 5;
            return Promise.all(promises);

          case 5:
            _context.t1 = _context.sent[0];
            return _context.abrupt("return", {
              match: _context.t0,
              data: _context.t1
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadInitialProps.apply(this, arguments);
}

export { loadInitialProps };
//# sourceMappingURL=loadInitialProps.esm.js.map
